import { gql } from '@apollo/client';

export default gql`
  query getFinances($start: Date, $end: Date, $search: String) {
    getFinances(start: $start, end: $end, search: $search) {
      ok
      error
      count
      data {
        _id
        branch
        autoNo
        docNo
        opType
        time
        title
        desc

        contractId
        contractName
        contractNameAr
        projectId
        projectName
        projectNameAr

        customerId
        customerName
        customerNameAr
        customerPhone

        employeeId
        employeeName
        employeeNameAr
        employeeColor

        refNo
        refType

        amount

        debitAcc
        debitAccName
        debitAccNameAr
        creditAcc
        creditAccName
        creditAccNameAr

        chequeBank
        chequeNo
        chequeDate

        procs

        attachments
        paymentType
        manualDocNo
        manualRefNo

        userId
        note

        createdAt
        updatedAt
      }
    }
  }
`;
